import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Avvisa quando c'e' una versione nuova, invece di ricaricare da solo.
 * In cantiere un reload a sorpresa mentre si compila un rilievo fa perdere
 * quello che si sta scrivendo: l'aggiornamento lo decide l'utente.
 */
export function AggiornamentoPWA() {
  const {
    needRefresh: [serveAggiornare, setServeAggiornare],
    updateServiceWorker,
  } = useRegisterSW();

  if (!serveAggiornare) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-sm">
      <div className="bg-white shadow-lg rounded-lg px-4 py-3 flex items-center gap-3 text-sm border border-gray-200">
        <span className="text-gray-700">C&apos;&egrave; una versione nuova dell&apos;app.</span>
        <button
          type="button"
          onClick={() => updateServiceWorker(true)}
          className="px-3 py-1 rounded-md bg-primary-600 text-white hover:bg-primary-700 whitespace-nowrap"
        >
          Aggiorna
        </button>
        <button
          type="button"
          onClick={() => setServeAggiornare(false)}
          className="text-gray-400 hover:text-gray-600"
          aria-label="Rimanda l'aggiornamento"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
